import { doc, getDoc } from "firebase/firestore";
import { useCallback, useEffect, useState } from "react";
import { firestore } from "../firebase";
import { mapPlaceDocumentToPlace, Place, PlaceDocument } from "../types/Place";

interface UsePlaceInfoReturn {
  place: Place | null;
  loading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const usePlaceInfo = (placeId: string | null): UsePlaceInfoReturn => {
  const [place, setPlace] = useState<Place | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const [doRefetch, setDoRefetch] = useState<boolean>(false);

  const refetch = useCallback(() => {
    setPlace(null);
    setLoading(true);
    setError(null);
    setDoRefetch(true);
  }, []);

  useEffect(() => {
    const fetchPlaceInfo = async () => {
      if (!placeId) {
        setPlace(null);
        setLoading(false);
        setError(null);
        return;
      }

      setLoading(true);
      setError(null);
      setDoRefetch(false);

      try {
        const placeDocRef = doc(firestore, "places", placeId);
        const placeDocSnap = await getDoc(placeDocRef);

        if (placeDocSnap.exists()) {
          setPlace(
            mapPlaceDocumentToPlace(placeDocSnap.data() as PlaceDocument)
          );
        } else {
          setPlace(null);
        }
      } catch (err) {
        setError(err as Error);
        setPlace(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPlaceInfo();
  }, [placeId, doRefetch]);

  return { place, loading, error, refetch };
};
